import _defineProperty from "@babel/runtime/helpers/defineProperty";
import throttle from 'lodash/throttle';
export class BatchQueueImpl {
  constructor(options) {
    this.options = options;
    _defineProperty(this, "queue", []);
    _defineProperty(this, "flushThrottled", void 0);
    this.flushThrottled = throttle(() => this.flush(), options.throttleDuration, {
      leading: false
    });
  }
  flush() {
    const events = this.queue.splice(0);
    this.options.flushHandler(events);
  }
  enqueue(payload) {
    this.queue.push(payload);
    this.flushThrottled();
  }
}
//# sourceMappingURL=batch-queue.js.map